import React from "react";
import theme from "../styles/theme";
import SurveyTab from "../components/surveys/SurveyTab";
import Sidebar from "../components/feed/Sidebar";

export default function SurveyPage() {
  return (
    <div style={{
      maxWidth: 1200, margin: "0 auto", padding: "32px 24px",
      display: "grid", gridTemplateColumns: "1fr 320px", gap: 28,
    }}>
      {/* Survey column */}
      <SurveyTab />

      {/* Sidebar */}
      <Sidebar />
    </div>
  );
}
